import { Scope } from '@tanbo/vue-di-plugin'

export const frontScope = new Scope('FrontScope')
